import { Component } from "react"
import PropTypes from "prop-types"

import Switch from "shared/components/switch"
import colors from "foundation/_colors_export.scss?variables"

const styles = {
  circle: {
    onColor: "white",
    offColor: "white",
  },

  switch: {
    onColor: colors.primaryTextColor,
    offColor: "rgba(0,0,0,0.5)",
  },
}
export default class PushNotifications extends Component {
  render() {
    return (
      <>
        <div className="connection-push-notifications">
          <p className="txt-body-3 info">Notify me when this runs</p>
          <Switch
            size="normal"
            backgroundColor={styles.switch.offColor}
            backgroundColorEnabled={styles.switch.onColor}
            circleColor={styles.circle.onColor}
            circleColorEnabled={styles.circle.onColor}
            onChange={this.props.onChange}
            value={this.props.pushEnabled}
          />
        </div>
      </>
    )
  }
}

PushNotifications.propTypes = {
  pushEnabled: PropTypes.bool,
  onChange: PropTypes.func,
}
